
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 49 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".861","width":"47.697","height":"22","rx":"4","fill":"#B7BEC5"}}),_c('path',{attrs:{"d":"M11.5 16V5.864h3.01c3.1 0 4.649 1.078 4.649 3.234 0 1.139-.402 1.97-1.204 2.492-.794.523-1.97.784-3.528.784h-.7V16H11.5zm2.227-5.432h.812c.896 0 1.516-.103 1.862-.308.354-.215.532-.565.532-1.05 0-.541-.192-.91-.574-1.106-.374-.196-.999-.294-1.876-.294h-.756v2.758zM20.442 16V5.864h2.842c2.007 0 3.542.439 4.606 1.316 1.064.868 1.596 2.114 1.596 3.738 0 1.605-.523 2.856-1.568 3.752-1.045.887-2.622 1.33-4.732 1.33h-2.744zm2.226-1.946h.616c2.65 0 3.976-1.045 3.976-3.136 0-1.11-.392-1.941-1.176-2.492-.578-.41-1.517-.616-2.814-.616h-.602v6.244zM30.846 16V5.864h6.426V7.81h-4.2v2.184h3.612v1.848h-3.612V16h-2.226z","fill":"#fff"}})])
          )
        }
      }
    